import React, { useEffect, useState, createElement } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Zap, Lock, DollarSign, Bot, X } from 'lucide-react';
import { Button } from '../components/Button';
import { Input } from '../components/Input';
import { Card } from '../components/Card';
import { NeuralBackground } from '../components/NeuralBackground';
import { Modal } from '../components/Modal';
declare global {
  interface Window {
    fbq: (action: string, event: string, params?: any) => void;
    _fbq?: any;
  }
}
type ModalType = 'privacy' | 'terms' | 'contact' | null;
export function LandingPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: ''
  });
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  useEffect(() => {
    const f = window as any;
    if (!f.fbq) {
      const n: any = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const target = document.head || document.body;
      if (target) {
        target.appendChild(script);
      }
    }
    window.fbq('init', '1348863570412843');
    window.fbq('track', 'PageView');
  }, []);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    alert('¡Gracias! Tu descarga comenzará pronto.');
  };
  return <div className="min-h-screen bg-[#050510] text-white overflow-x-hidden" data-id="element-24">
      <NeuralBackground data-id="element-25" />

      <div className="relative z-10" data-id="element-26">
        {/* Hero Section */}
        <section className="relative min-h-screen flex items-center justify-center px-4 py-20" data-id="element-27">
          <div className="max-w-6xl mx-auto w-full" data-id="element-28">
            <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-29">
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.6
            }} data-id="element-30">
                {/* Badge */}
                <motion.div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border-2 border-[#FFD700] bg-[#FFD700]/10 mb-8" whileHover={{
                scale: 1.05
              }} data-id="element-31">
                  <Zap className="w-4 h-4 text-[#FFD700]" data-id="element-32" />
                  <span className="text-[#FFD700] font-bold text-sm" data-id="element-33">
                    MÉTODO EXCLUSIVO
                  </span>
                </motion.div>

                {/* Main Headline */}
                <h1 className="font-['Space_Grotesk'] font-bold text-white mb-4" data-id="element-34">
                  <div className="text-4xl md:text-6xl lg:text-7xl leading-tight" data-id="element-35">
                    Lanza Tu Primer
                  </div>
                  <div className="text-4xl md:text-6xl lg:text-7xl leading-tight" data-id="element-36">
                    Producto Digital
                  </div>
                  <div className="text-4xl md:text-6xl lg:text-7xl leading-tight" data-id="element-37">
                    En 48 Horas
                  </div>
                </h1>

                {/* Subheadline */}
                <div className="text-2xl md:text-3xl font-bold bg-gradient-to-r from-[#00D4FF] to-[#00FF88] bg-clip-text text-transparent mb-6" data-id="element-38">
                  Usando Inteligencia Artificial
                </div>

                {/* Description */}
                <p className="text-[#B0B8CC] text-base md:text-lg leading-relaxed mb-8" data-id="element-39">
                  Descarga GRATIS el sistema paso a paso que está ayudando a
                  cientos de emprendedores a generar sus primeros ingresos
                  digitales sin experiencia técnica previa
                </p>

                {/* CTA Button */}
                <Button variant="primary" size="lg" onClick={() => {
                const ctaSection = document.getElementById('final-cta');
                if (ctaSection) {
                  ctaSection.scrollIntoView({
                    behavior: 'smooth'
                  });
                }
              }} data-id="element-40">
                  ⚡ QUIERO MIS 48 HORAS GRATIS
                </Button>
              </motion.div>

              {/* Hero Image */}
              <motion.div className="relative" initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              duration: 0.6,
              delay: 0.2
            }} data-id="element-41">
                <img src="https://cdn.magicpatterns.com/uploads/tgbUj2Y9xurKAWuAxUQNdk/ChatGPT_Image_14_jun_2026,_20_18_33.png" alt="48 Hours AI Cash Machine" className="w-full h-auto rounded-2xl shadow-[0_0_50px_rgba(0,212,255,0.3)]" data-id="element-42" />
              </motion.div>
            </div>
          </div>
        </section>

        {/* Social Proof Bar */}
        <section className="py-12 px-4 border-y border-[#00D4FF]/20" data-id="element-43">
          <div className="max-w-6xl mx-auto" data-id="element-44">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center" data-id="element-45">
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.1
            }} data-id="element-46">
                <div className="font-['Space_Grotesk'] text-4xl md:text-5xl font-bold bg-gradient-to-r from-[#FFD700] to-[#00D4FF] bg-clip-text text-transparent" data-id="element-47">
                  +2,400
                </div>
                <div className="text-[#B0B8CC] mt-2" data-id="element-48">Emprendedores activos</div>
              </motion.div>
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.2
            }} className="md:border-x border-[#00D4FF]/20" data-id="element-49">
                <div className="font-['Space_Grotesk'] text-4xl md:text-5xl font-bold bg-gradient-to-r from-[#00D4FF] to-[#00FF88] bg-clip-text text-transparent" data-id="element-50">
                  48 HRS
                </div>
                <div className="text-[#B0B8CC] mt-2" data-id="element-51">Para ver resultados</div>
              </motion.div>
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.3
            }} data-id="element-52">
                <div className="font-['Space_Grotesk'] text-4xl md:text-5xl font-bold text-[#00FF88]" data-id="element-53">
                  100%
                </div>
                <div className="text-[#B0B8CC] mt-2" data-id="element-54">Gratuito</div>
              </motion.div>
            </div>
          </div>
        </section>

        {/* Ebook Mockup Section */}
        <section className="py-20 px-4" data-id="element-55">
          <div className="max-w-4xl mx-auto text-center" data-id="element-56">
            <motion.div className="relative inline-block" initial={{
            opacity: 0,
            scale: 0.8
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} data-id="element-57">
              {/* 3D Book Mockup */}
              <div className="relative" data-id="element-58">
                <div className="w-64 h-80 mx-auto bg-gradient-to-br from-[#0A0A2E] to-[#050510] rounded-lg shadow-[0_20px_60px_rgba(0,212,255,0.4)] border-2 border-[#00D4FF]/50 transform perspective-1000 rotate-y-12 flex items-center justify-center p-8" data-id="element-59">
                  <div className="text-center" data-id="element-60">
                    <div className="text-3xl font-bold text-[#00D4FF] mb-2" data-id="element-61">
                      48 HOURS
                    </div>
                    <div className="text-2xl font-bold text-[#FFD700]" data-id="element-62">
                      AI CASH
                    </div>
                    <div className="text-2xl font-bold text-[#FFD700]" data-id="element-63">
                      MACHINE
                    </div>
                  </div>
                </div>

                {/* FREE Badge */}
                <div className="absolute -top-4 -right-4 bg-gradient-to-r from-[#FF4444] to-[#FF8C00] text-white font-bold px-4 py-2 rounded-full shadow-lg transform rotate-12" data-id="element-64">
                  GUIA FREE
                </div>
              </div>

              {/* Floating Icons */}
              <motion.div className="absolute -left-8 top-1/4" animate={{
              y: [0, -10, 0]
            }} transition={{
              duration: 2,
              repeat: Infinity
            }} data-id="element-65">
                <DollarSign className="w-8 h-8 text-[#FFD700]" data-id="element-66" />
              </motion.div>
              <motion.div className="absolute -right-8 top-1/3" animate={{
              y: [0, 10, 0]
            }} transition={{
              duration: 2.5,
              repeat: Infinity
            }} data-id="element-67">
                <Zap className="w-8 h-8 text-[#00D4FF]" data-id="element-68" />
              </motion.div>
              <motion.div className="absolute left-1/2 -bottom-8" animate={{
              y: [0, -10, 0]
            }} transition={{
              duration: 3,
              repeat: Infinity
            }} data-id="element-69">
                <Bot className="w-8 h-8 text-[#00FF88]" data-id="element-70" />
              </motion.div>
            </motion.div>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="py-20 px-4 bg-gradient-to-b from-transparent to-[#0A0A2E]/50" data-id="element-71">
          <div className="max-w-4xl mx-auto" data-id="element-72">
            <motion.h2 className="text-3xl md:text-4xl font-bold text-white mb-12" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-73">
              Lo Que Vas a Descubrir:
            </motion.h2>

            <div className="space-y-6" data-id="element-74">
              {[{
              title: 'Cómo elegir y validar tu producto digital en menos de 2 horas con IA',
              description: 'Aprende a identificar nichos rentables y validar ideas sin perder tiempo'
            }, {
              title: 'Los prompts exactos de IA que hacen el trabajo por ti',
              description: 'Plantillas listas para usar que generan contenido de calidad profesional'
            }, {
              title: 'Plataformas gratuitas para vender sin inversión inicial',
              description: 'Descubre las mejores herramientas para empezar sin gastar un centavo'
            }, {
              title: 'La estrategia de lanzamiento express que genera tus primeras ventas en 48h',
              description: 'El método probado para conseguir clientes desde el primer día'
            }, {
              title: 'El sistema de automatización para que tu producto venda mientras duermes',
              description: 'Configura una vez y genera ingresos pasivos de forma automática'
            }].map((benefit, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} data-id="element-75">
                  <Card className="hover:border-[#00D4FF]/60 transition-all duration-300" data-id="element-76">
                    <div className="flex gap-4" data-id="element-77">
                      <CheckCircle2 className="w-6 h-6 text-[#00FF88] flex-shrink-0 mt-1" data-id="element-78" />
                      <div data-id="element-79">
                        <h3 className="text-white font-bold text-lg mb-2" data-id="element-80">
                          {benefit.title}
                        </h3>
                        <p className="text-[#8892A4] text-sm" data-id="element-81">
                          {benefit.description}
                        </p>
                      </div>
                    </div>
                  </Card>
                </motion.div>)}
            </div>
          </div>
        </section>

        {/* Authority Section */}
        <section className="py-20 px-4 bg-gradient-to-b from-[#0A0A2E]/50 to-transparent" data-id="element-82">
          <div className="max-w-3xl mx-auto" data-id="element-83">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-84">
              <Card data-id="element-85">
                <div className="flex flex-col md:flex-row items-center gap-6" data-id="element-86">
                  <div className="w-24 h-24 rounded-full bg-gradient-to-br from-[#00D4FF] to-[#0066FF] flex items-center justify-center text-3xl font-bold flex-shrink-0" data-id="element-87">
                    GB
                  </div>
                  <div className="text-center md:text-left" data-id="element-88">
                    <div className="flex items-center gap-2 justify-center md:justify-start mb-2" data-id="element-89">
                      <h3 className="text-2xl font-bold text-white" data-id="element-90">
                        Gabriel Beltrán
                      </h3>
                      <div className="w-6 h-6 rounded-full bg-[#00D4FF] flex items-center justify-center" data-id="element-91">
                        <CheckCircle2 className="w-4 h-4 text-white" data-id="element-92" />
                      </div>
                    </div>
                    <p className="text-[#00D4FF] font-semibold mb-3" data-id="element-93">
                      Mentor de Alto Nivel en Marketing Digital
                    </p>
                    <p className="text-[#B0B8CC] text-sm" data-id="element-94">
                      Fundador de TrueMarketer. Experto en comercio electrónico,
                      marketing de afiliados y negocios digitales con IA
                    </p>
                  </div>
                </div>
              </Card>
            </motion.div>
          </div>
        </section>

        {/* Testimonials Section */}
        <section className="py-20 px-4" data-id="element-95">
          <div className="max-w-6xl mx-auto" data-id="element-96">
            <div className="grid md:grid-cols-3 gap-6" data-id="element-97">
              {[{
              text: 'En menos de 48 horas tenía mi primer ebook listo y ya había hecho mis primeras 3 ventas. ¡Increíble sistema!',
              author: 'María G.',
              location: 'Venezuela'
            }, {
              text: 'No sabía nada de productos digitales. HeyLloyd me guió paso a paso y ahora genero ingresos desde mi celular.',
              author: 'Carlos R.',
              location: 'México'
            }, {
              text: 'La IA hace el trabajo pesado. Yo solo seguí el sistema y vendí mi primer producto en 36 horas.',
              author: 'Ana M.',
              location: 'Colombia'
            }].map((testimonial, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} data-id="element-98">
                  <Card className="h-full" data-id="element-99">
                    <div className="flex gap-1 mb-4" data-id="element-100">
                      {[...Array(5)].map((_, i) => <span key={i} className="text-[#FFD700] text-xl" data-id="element-101">
                          ⭐
                        </span>)}
                    </div>
                    <p className="text-white mb-4 leading-relaxed" data-id="element-102">
                      {testimonial.text}
                    </p>
                    <p className="text-[#00D4FF] font-semibold" data-id="element-103">
                      {testimonial.author}, {testimonial.location}
                    </p>
                  </Card>
                </motion.div>)}
            </div>
          </div>
        </section>

        {/* Urgency Section */}
        <section className="py-12 px-4" data-id="element-104">
          <div className="max-w-4xl mx-auto" data-id="element-105">
            <motion.div className="bg-gradient-to-r from-[#FF4444]/20 to-[#FF8C00]/20 border-2 border-[#FF4444] rounded-2xl p-8 text-center" initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} whileHover={{
            scale: 1.02
          }} data-id="element-106">
              <div className="text-2xl md:text-3xl font-bold text-white mb-2" data-id="element-107">
                ⏰ Esta guía gratuita tiene cupos limitados
              </div>
              <div className="text-xl text-[#FF4444] font-semibold" data-id="element-108">
                Solo quedan <span className="text-3xl font-bold" data-id="element-109">23</span>{' '}
                descargas disponibles hoy
              </div>
            </motion.div>
          </div>
        </section>

        {/* Final CTA Section */}
        <section id="final-cta" className="py-20 px-4 bg-gradient-to-b from-transparent to-[#0A0A2E]/50" data-id="element-110">
          <div className="max-w-3xl mx-auto text-center" data-id="element-111">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-112">
              <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-113">
                ¿Listo Para Lanzar Tu Producto Digital?
              </h2>
              <p className="text-xl text-[#B0B8CC] mb-8" data-id="element-114">
                Empieza hoy. Resultados en 48 horas.
              </p>
              <Button variant="primary" size="lg" onClick={() => {
              window.fbq('track', 'AddToCart');
              window.location.href = 'https://aeduclub.com/cart/48061268263130:1';
            }} data-id="element-115">
                ⚡ QUIERO MIS 48 HORAS GRATIS
              </Button>
            </motion.div>
          </div>
        </section>

        {/* Footer */}
        <footer className="py-12 px-4 border-t border-[#00D4FF]/20" data-id="element-116">
          <div className="max-w-6xl mx-auto" data-id="element-117">
            <div className="text-center space-y-4" data-id="element-118">
              <div className="text-2xl font-bold bg-gradient-to-r from-[#00D4FF] to-[#00FF88] bg-clip-text text-transparent" data-id="element-119">
                A+ EDUCATIONAL CLUB, INC
              </div>
              <div className="text-[#B0B8CC]" data-id="element-120">
                © 2025 Bienvenido al Programa de Afiliados de Gabriel Beltrán
                True Marketer
              </div>
              <div className="flex justify-center gap-6 text-sm text-[#8892A4]" data-id="element-121">
                <button onClick={() => setActiveModal('privacy')} className="hover:text-[#00D4FF] transition-colors cursor-pointer" data-id="element-122">
                  Privacidad
                </button>
                <span data-id="element-123">|</span>
                <button onClick={() => setActiveModal('terms')} className="hover:text-[#00D4FF] transition-colors cursor-pointer" data-id="element-124">
                  Términos
                </button>
                <span data-id="element-125">|</span>
                <button onClick={() => setActiveModal('contact')} className="hover:text-[#00D4FF] transition-colors cursor-pointer" data-id="element-126">
                  Contacto
                </button>
              </div>
              <p className="text-xs text-[#8892A4] max-w-2xl mx-auto" data-id="element-127">
                Este sitio no es parte de Facebook Inc. Además, este sitio NO
                está respaldado por Facebook de ninguna manera.
              </p>
            </div>
          </div>
        </footer>
      </div>

      {/* Privacy Modal */}
      <Modal isOpen={activeModal === 'privacy'} onClose={() => setActiveModal(null)} title="Política de Privacidad" data-id="element-128">
        <div className="space-y-4 text-[#B0B8CC]" data-id="element-129">
          <p data-id="element-130">
            En A+ Educational Club, Inc., nos comprometemos a proteger tu
            privacidad y la seguridad de tus datos personales.
          </p>
          <h3 className="text-white font-bold text-lg mt-6" data-id="element-131">
            Información que Recopilamos
          </h3>
          <p data-id="element-132">
            Recopilamos información personal que nos proporcionas
            voluntariamente, como tu nombre y dirección de correo electrónico,
            cuando te registras para recibir nuestros recursos educativos
            gratuitos.
          </p>
          <h3 className="text-white font-bold text-lg mt-6" data-id="element-133">
            Uso de la Información
          </h3>
          <p data-id="element-134">
            Utilizamos tu información para enviarte el contenido solicitado,
            mejorar nuestros servicios y comunicarnos contigo sobre productos y
            ofertas que puedan ser de tu interés. Nunca vendemos ni compartimos
            tu información personal con terceros sin tu consentimiento.
          </p>
          <h3 className="text-white font-bold text-lg mt-6" data-id="element-135">
            Seguridad de Datos
          </h3>
          <p data-id="element-136">
            Implementamos medidas de seguridad técnicas y organizativas para
            proteger tus datos personales contra acceso no autorizado, pérdida o
            alteración.
          </p>
          <h3 className="text-white font-bold text-lg mt-6" data-id="element-137">Tus Derechos</h3>
          <p data-id="element-138">
            Tienes derecho a acceder, rectificar o eliminar tus datos personales
            en cualquier momento. Para ejercer estos derechos, contáctanos en
            aeducationalclub@gmail.com
          </p>
          <h3 className="text-white font-bold text-lg mt-6" data-id="element-139">Cookies</h3>
          <p data-id="element-140">
            Utilizamos cookies para mejorar tu experiencia en nuestro sitio web.
            Puedes configurar tu navegador para rechazar cookies, aunque esto
            puede afectar la funcionalidad del sitio.
          </p>
        </div>
      </Modal>

      {/* Terms Modal */}
      <Modal isOpen={activeModal === 'terms'} onClose={() => setActiveModal(null)} title="Términos y Condiciones" data-id="element-141">
        <div className="space-y-4 text-[#B0B8CC]" data-id="element-142">
          <p data-id="element-143">
            Bienvenido a A+ Educational Club, Inc. Al acceder y utilizar este
            sitio web, aceptas cumplir con los siguientes términos y
            condiciones.
          </p>
          <h3 className="text-white font-bold text-lg mt-6" data-id="element-144">
            Uso del Servicio
          </h3>
          <p data-id="element-145">
            Nuestros recursos educativos están diseñados para uso personal y
            educativo. No puedes redistribuir, vender o utilizar comercialmente
            el contenido sin autorización expresa.
          </p>
          <h3 className="text-white font-bold text-lg mt-6" data-id="element-146">
            Propiedad Intelectual
          </h3>
          <p data-id="element-147">
            Todo el contenido, incluyendo textos, gráficos, logos y software, es
            propiedad de A+ Educational Club, Inc. o sus licenciantes y está
            protegido por leyes de derechos de autor.
          </p>
          <h3 className="text-white font-bold text-lg mt-6" data-id="element-148">
            Descargo de Responsabilidad
          </h3>
          <p data-id="element-149">
            El contenido se proporciona "tal cual" con fines informativos. No
            garantizamos resultados específicos y no somos responsables de las
            decisiones tomadas basándose en nuestro contenido.
          </p>
          <h3 className="text-white font-bold text-lg mt-6" data-id="element-150">
            Limitación de Responsabilidad
          </h3>
          <p data-id="element-151">
            A+ Educational Club, Inc. no será responsable de daños directos,
            indirectos, incidentales o consecuentes que surjan del uso o la
            imposibilidad de usar nuestros servicios.
          </p>
          <h3 className="text-white font-bold text-lg mt-6" data-id="element-152">Modificaciones</h3>
          <p data-id="element-153">
            Nos reservamos el derecho de modificar estos términos en cualquier
            momento. El uso continuado del sitio después de cambios constituye
            tu aceptación de los nuevos términos.
          </p>
          <h3 className="text-white font-bold text-lg mt-6" data-id="element-154">Contacto</h3>
          <p data-id="element-155">
            Para preguntas sobre estos términos, contáctanos en
            aeducationalclub@gmail.com
          </p>
        </div>
      </Modal>

      {/* Contact Modal */}
      <Modal isOpen={activeModal === 'contact'} onClose={() => setActiveModal(null)} title="Información de Contacto" data-id="element-156">
        <div className="space-y-6 text-[#B0B8CC]" data-id="element-157">
          <div className="text-center" data-id="element-158">
            <div className="text-2xl font-bold bg-gradient-to-r from-[#00D4FF] to-[#00FF88] bg-clip-text text-transparent mb-4" data-id="element-159">
              A+ EDUCATIONAL CLUB, INC
            </div>
            <p className="text-lg mb-6" data-id="element-160">
              Estamos aquí para ayudarte en tu camino hacia el éxito digital.
            </p>
          </div>

          <div className="bg-white/5 rounded-xl p-6 border border-[#00D4FF]/20" data-id="element-161">
            <h3 className="text-white font-bold text-lg mb-4" data-id="element-162">
              Correo Electrónico
            </h3>
            <a href="mailto:aeducationalclub@gmail.com" className="text-[#00D4FF] hover:text-[#00FF88] transition-colors text-lg font-semibold" data-id="element-163">
              aeducationalclub@gmail.com
            </a>
          </div>

          <div className="bg-white/5 rounded-xl p-6 border border-[#00D4FF]/20" data-id="element-164">
            <h3 className="text-white font-bold text-lg mb-4" data-id="element-165">
              Horario de Atención
            </h3>
            <p data-id="element-166">Lunes a Viernes: 9:00 AM - 6:00 PM (EST)</p>
            <p className="text-sm mt-2" data-id="element-167">
              Responderemos tu consulta dentro de 24-48 horas hábiles.
            </p>
          </div>

          <div className="text-center mt-6" data-id="element-168">
            <p className="text-sm" data-id="element-169">
              ¿Tienes preguntas sobre nuestros programas o necesitas soporte
              técnico? No dudes en contactarnos. Estamos comprometidos con tu
              éxito.
            </p>
          </div>
        </div>
      </Modal>
    </div>;
}